import {
  Text,
  Button,
  HStack,
  Modal,
  useToast,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalContent,
} from '@chakra-ui/react'
import React, { useState } from 'react'
import { CheckCircleIcon } from '@chakra-ui/icons'
import { REPOSITORY } from '../../../api/repository/Repository'
import GiftIcon from '../../../components/SvgIcon/icons/GiftIcon'
import { useLoadingContext } from '../../../utils/hooks/Context/LoadingContext'

export function GiftCardAction() {
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()

  const [isOpen, setIsOpen] = useState(false)
  const toast = useToast()

  const handleOpenModal = async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.dashboard
      .SolicitudContactoGiftCard()
      .then(() => {
        setIsOpen(true)
      })
      .catch((error) => {
        console.error('Error enviando el correo:', error)
        toast({
          title: 'Error.',
          description: 'Hubo un problema al enviar la solicitud.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
      })
      .finally(() => {
        handleCLoseLoading()
      })
  }

  const handleCloseModal = () => {
    setIsOpen(false)
  }

  return (
    <>
      <Button
        onClick={handleOpenModal}
        style={{
          margin: 0,
          paddingTop: 25,
          paddingBottom: 25,
          width: 'fit-content',
          borderColor: '#40A4E0',
          backgroundColor: '#40A4E0',
          boxShadow: '3px 4px 9px 0px #00000026',
        }}
      >
        <HStack>
          <GiftIcon width="30" height="30" color="#ffffff" />
          <Text style={{ color: '#FFFFFF', textAlign: 'start' }} fontSize={14}>
            Pide tus giftcard aquí
          </Text>
        </HStack>
      </Button>
      <Modal isOpen={isOpen} onClose={handleCloseModal} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader display="flex" alignItems="center">
            <CheckCircleIcon color="green.500" boxSize={6} />
          </ModalHeader>
          <ModalBody textAlign={'center'}>
            <b>Serás contactado por tu Ejecutiva.</b>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={handleCloseModal}>
              Aceptar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
